import types from "resources/types";
import { createResourceDetailQuery, createResourceListQuery } from "queries";

export const invoicesQuery = (config = {}) => () =>
  createResourceListQuery(types.INVOICES, {
    url: "/api/dev/invoices/?limit=999",
    ...config,
  });
